import React, { useRef, useEffect, useState } from "react";
import { Task } from "../../types/public-types";
import { BarTask } from "../../types/bar-task";
import styles from "./tooltip.module.css";
export type TooltipProps = {
  task: BarTask;
  endTask: BarTask;
  wrapperRef: React.RefObject<HTMLDivElement>;
};

export const DepandanyLineTooltip: React.FC<TooltipProps> = ({
  task,
  endTask,
  wrapperRef,
}) => {
  const tooltipRef = useRef<HTMLDivElement | null>(null);
  const [mouseX, setMouseX] = useState(task.x1);
  const [mouseY, setMouseY] = useState(task.y);

  useEffect(() => {
    const ganttElement = document.querySelector<HTMLElement>(".gridBody");
    if (!ganttElement) return;

    const handleMouseMove = (event: MouseEvent) => {
      if (wrapperRef && wrapperRef.current) {
        const wrapperRect = wrapperRef.current.getBoundingClientRect();
        let newMouseX = event.clientX - wrapperRect.left;
        let newMouseY = event.clientY - wrapperRect.top;
  
        // Ensure the tooltip stays within the screen bounds
        const tooltipWidth = tooltipRef.current?.offsetWidth || 0;
        const tooltipHeight = tooltipRef.current?.offsetHeight || 0;
        const maxX = wrapperRect.width - tooltipWidth;
        const maxY = wrapperRect.height - tooltipHeight;
  
        if (newMouseX > maxX) {
          newMouseX = event.clientX - wrapperRect.left - tooltipWidth;
        }
        if (newMouseY > maxY) {
          newMouseY = event.clientY - wrapperRect.top - tooltipHeight;
        }
  
        setMouseX(Math.max(0, Math.min(newMouseX, maxX)));
        setMouseY(Math.max(0, Math.min(newMouseY, maxY)));
      }
    };
    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []); // Empty dependency array to ensure the effect runs only once

  const tooltipStyle = {
    left: `${mouseX}px`, // Offset to avoid covering the mouse pointer
    top: `${mouseY }px`,
  };
  return (
    <div
      ref={tooltipRef}
      className={styles.tooltipDetailsContainer}
      style={tooltipStyle}
    >
      <StandardTooltipContent task={task} endTask={endTask} />
    </div>
  );
};

export const StandardTooltipContent: React.FC<{
  task: Task;
  endTask: Task;
}> = ({ task, endTask }) => {
  return (
    <div
      className={
        styles.tooltipDefaultContainer +
        " rounded-md flex flex-row-reverse !p-0 "
      }
    >
      <div className="bg-white rounded-md p-2 ">
        From
        <br />
        <p className="text-base font-semibold">{task.name}</p>
        To
        <br />
        <p className="text-base font-semibold">{endTask.name}</p>
      </div>
    </div>
  );
};
